import React from 'react';
import PropTypes from 'prop-types';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';

const Appointees = ({
    row,
    col,
    selected,
    onCellChange,
    keyValue
}) => {
    const { teams, team, appointee } = row;

    if (team && selected) {
        const { [team] : appointees } = teams;
        const { field } = col;

        return (
            <Select id={`${keyValue}-appointee-selector`} value={appointee} onChange={e => onCellChange(e, field)} displayEmpty >
                <MenuItem value="" disabled key={`${keyValue}-appointee-default`}>Select</MenuItem>
                {
                    appointees.map(_appointee => (
                        <MenuItem value={_appointee} key={`${keyValue}-appointee-${_appointee.appointeeId}`}>
                            {`${_appointee.initials} ${_appointee.name}`}
                        </MenuItem>
                    ))
                }
            </Select>
        );
    }
    if (team && appointee && !selected) {
        return `${appointee.initials} ${appointee.name}`;
    }
    return null;
};

Appointees.propTypes = {
    row: PropTypes.object.isRequired,
    col: PropTypes.object.isRequired,
    selected: PropTypes.bool
};

export default Appointees;